<script lang="ts" setup>
/* eslint-disable vue/max-len */
// The three body panels of the envelope's back side: a left triangle
// curving inward from the left edge, a right triangle mirroring it,
// and a bottom triangle pointing up. Together they meet in the center
// at the envelope's "spine". The matching top flap is rendered
// separately by `EnvelopeFlap.vue` so it can rotate independently.
//
// Fills are `currentColor` so the parent envelope can theme via
// `color: var(--env-color)` instead of hard-coding red.
</script>

<template>
  <svg
    class="env-back-body"
    viewBox="0 0 320 320"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="none"
    aria-hidden="true"
  >
    <g clip-path="url(#env-back-clip0)">
      <g clip-path="url(#env-back-clip1)">
        <g filter="url(#env-back-filter0)">
          <path
            d="M160.26 138.392C172.668 149.828 178.872 155.547 181.171 162.248C183.191 168.137 183.191 174.53 181.171 180.418C178.872 187.12 172.668 192.838 160.26 204.275L46.1627 309.44C22.4034 331.339 10.5238 342.288 0.400584 342.795C-8.39072 343.236 -16.8773 339.516 -22.5118 332.753C-28.9999 324.966 -28.9999 308.81 -28.9999 276.498L-28.9999 66.1687C-28.9999 33.8566 -28.9999 17.7005 -22.5118 9.91329C-16.8773 3.15062 -8.3907 -0.568811 0.400598 -0.128554C10.5238 0.378403 22.4034 11.328 46.1627 33.2271L160.26 138.392Z"
            fill="currentColor"
          />
        </g>
        <g filter="url(#env-back-filter1)">
          <path
            d="M158.74 138.392C146.332 149.828 140.127 155.547 137.829 162.248C135.809 168.137 135.809 174.53 137.829 180.418C140.127 187.12 146.332 192.838 158.74 204.275L272.837 309.44C296.596 331.339 308.476 342.288 318.599 342.795C327.391 343.236 335.877 339.516 341.512 332.753C348 324.966 348 308.81 348 276.498L348 66.1687C348 33.8566 348 17.7005 341.512 9.91329C335.877 3.15062 327.391 -0.568811 318.599 -0.128554C308.476 0.378403 296.596 11.328 272.837 33.2271L158.74 138.392Z"
            fill="currentColor"
          />
        </g>
        <g filter="url(#env-back-filter2)">
          <path
            d="M329.245 258.496C359.539 297.442 374.686 316.915 374.547 333.265C374.427 347.488 367.872 360.891 356.719 369.719C343.899 379.866 319.229 379.866 269.888 379.866H50.8719C1.53091 379.866 -23.1396 379.866 -35.9597 369.719C-47.1121 360.891 -53.6671 347.488 -53.7878 333.265C-53.9265 316.915 -38.7796 297.442 -8.48573 258.496L92.2175 129.03C100.504 118.376 104.647 113.049 109.836 109.212C114.432 105.813 119.61 103.28 125.115 101.74C131.33 100 138.078 100 151.575 100H169.184C182.681 100 189.429 100 195.644 101.74C201.149 103.28 206.327 105.813 210.923 109.212C216.112 113.049 220.255 118.376 228.542 129.03L329.245 258.496Z"
            fill="currentColor"
          />
        </g>
      </g>
    </g>
    <defs>
      <filter
        id="env-back-filter0"
        x="-31.9999"
        y="-4.16357"
        width="215.686"
        height="346.994"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset dx="-1" dy="-2"/>
        <feGaussianBlur stdDeviation="1"/>
        <feComposite in2="hardAlpha" operator="out"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
      </filter>
      <filter
        id="env-back-filter1"
        x="135.314"
        y="-4.16357"
        width="215.686"
        height="346.994"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset dx="1" dy="-2"/>
        <feGaussianBlur stdDeviation="1"/>
        <feComposite in2="hardAlpha" operator="out"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
      </filter>
      <filter
        id="env-back-filter2"
        x="-54.4887"
        y="98.3"
        width="429.737"
        height="281.566"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset dy="-1"/>
        <feGaussianBlur stdDeviation="0.35"/>
        <feComposite in2="hardAlpha" operator="out"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>
      </filter>
      <clipPath id="env-back-clip0">
        <rect width="320" height="320" fill="white"/>
      </clipPath>
      <clipPath id="env-back-clip1">
        <rect width="320" height="320" fill="white"/>
      </clipPath>
    </defs>
  </svg>
</template>

<style scoped lang="scss">
.env-back-body {
  display: block;
  height: 100%;
  width: 100%;
}
</style>
